/*
GPS DataViz

Copyright © 2021 GPSDataViz

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/

import React, { useEffect, useRef } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import {Button} from "antd";

import "../Styles/styles-Login.css";
import { OnBoardingNav } from "./Navigation/OnBoardingNav";

// const layout = {
//   labelCol: { span: 8 },
//   wrapperCol: { span: 16 },
// };
// const tailLayout = {
//   wrapperCol: { offset: 8, span: 16 },
// };

// const onFinish = (values) => {
//   console.log("Success:", values);
// };

// const onFinishFailed = (errorInfo) => {
//   console.log("Failed:", errorInfo);
// };

export const Login = () => {

  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();
  const redirecting = useRef(false);

  useEffect(() => {
    // Wait for Auth0 to resolve the session. If the user is already
    // authenticated, the <Auth> redirect effect routes them onward.
    if (isLoading || isAuthenticated) return;
    // Auto-redirect to Auth0, but only fire once across re-renders.
    if (redirecting.current) return;
    redirecting.current = true;
    loginWithRedirect();
  }, [isLoading, isAuthenticated, loginWithRedirect]);

  return (
    <>
      {/* <OnBoardingNav /> */}
      {/* <div className="login-content"> */}
        <Button 
          type="primary"
          shape="circle"
          onClick={() => loginWithRedirect()}
          style={{marginTop: '45vh', height: '7em', width: '7em'}}
        >
          <span style={{fontSize: '1em'}}>Log In</span>
        </Button>

      {/* </div> */}

      {/* <Wave fill='#ff7300'
        paused={false}
        style={{ display: 'flex', position: 'absolute', bottom: 0, height: '50vh'}}
        options={{
          height: 20,
          amplitude: 45,
          speed: 0.2,
          points: 7
        }}
  /> */}
    </>
  );
};
